import { isActionRunning } from '@pulsify/shared'
import { Link } from '@tanstack/react-router'
import { Megaphone } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { useListingActions } from '~/entities/listing-action/model/use-listing-actions'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { Card } from '~/shared/ui/card'

export function ActionPlaceCard({ listingId }: { listingId: string }) {
  const { data: business } = useCurrentBusiness()
  const actions = useListingActions(business?.id ?? '', listingId)
  const current = actions.data?.running
  const running = current && isActionRunning(current, new Date()) ? current : null

  return (
    <Card className="flex flex-col gap-3 p-6 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        <Megaphone className="mt-1 size-5 shrink-0 text-brand-subtle-foreground" aria-hidden />
        <div className="min-w-0">
          <h2 className="font-semibold text-foreground">{m.actionPlaceCardTitle()}</h2>
          <p className="break-words text-muted-foreground text-sm">
            {running ? m.actionPlaceCardRunning({ text: running.text }) : m.actionPlaceCardBody()}
          </p>
        </div>
      </div>
      <Button asChild variant="outline" className="w-fit shrink-0">
        <Link to="/dashboard/actions" search={{ listingId }}>
          {m.actionPlaceCardOpen()}
        </Link>
      </Button>
    </Card>
  )
}
